var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarchartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2087 12.75H30.4587V29.75H26.2087V12.75ZM20.542 18.4167H24.792V29.75H20.542V18.4167ZM14.8753 15.5833H19.1253V29.75H14.8753V15.5833ZM9.20866 22.6667H13.4587V29.75H9.20866V22.6667ZM3.54199 19.8333H7.79199V29.75H3.54199V19.8333Z",
    fill: "#00BCD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66699 13.459C6.8406 13.459 7.79199 12.5076 7.79199 11.334C7.79199 10.1604 6.8406 9.20898 5.66699 9.20898C4.49339 9.20898 3.54199 10.1604 3.54199 11.334C3.54199 12.5076 4.49339 13.459 5.66699 13.459Z",
    fill: "#3F51B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 14.875C12.5076 14.875 13.459 13.9236 13.459 12.75C13.459 11.5764 12.5076 10.625 11.334 10.625C10.1604 10.625 9.20898 11.5764 9.20898 12.75C9.20898 13.9236 10.1604 14.875 11.334 14.875Z",
    fill: "#3F51B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.91602C18.1736 9.91602 19.125 8.96462 19.125 7.79102C19.125 6.61741 18.1736 5.66602 17 5.66602C15.8264 5.66602 14.875 6.61741 14.875 7.79102C14.875 8.96462 15.8264 9.91602 17 9.91602Z",
    fill: "#3F51B5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 11.334C23.8406 11.334 24.792 10.3826 24.792 9.20898C24.792 8.03538 23.8406 7.08398 22.667 7.08398C21.4934 7.08398 20.542 8.03538 20.542 9.20898C20.542 10.3826 21.4934 11.334 22.667 11.334Z",
    fill: "#3F51B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.334 8.5C29.5076 8.5 30.459 7.5486 30.459 6.375C30.459 5.20139 29.5076 4.25 28.334 4.25C27.1604 4.25 26.209 5.20139 26.209 6.375C26.209 7.5486 27.1604 8.5 28.334 8.5Z",
    fill: "#3F51B5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6958 5.09961L22.525 7.72044L16.6458 6.23294L10.9792 11.1913L6.02083 9.98711L5.3125 12.6788L11.6875 14.3079L17.3542 9.34961L22.8083 10.6954L28.9708 7.64961L27.6958 5.09961Z",
    fill: "#3F51B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarchartIcon);
export default __webpack_public_path__ + "static/media/barchartIcon.be2395775ed30cdf86c2464e63c1e3bc.svg";
export { ForwardRef as ReactComponent };